import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IServiceProvider, IServiceProviderRequest } from "@ontime/types";

const API_URL = (organizationId: string) => `${ApiURL()}/organizations/${organizationId}/serviceProvider`;

class ServiceProviderService {

    async GetList(organizationId: string, showDeleted: boolean = false): Promise<IServiceProvider[]> {
        const response = await axios.get<IServiceProvider[]>(API_URL(organizationId), {
            headers: AuthHeader(),
            params: { showDeleted }
        });
        return response.data;
    }

    async Get(organizationId: string, serviceProviderId: string): Promise<IServiceProvider> {
        const response = await axios.get<IServiceProvider>(`${API_URL(organizationId)}/${serviceProviderId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, input: IServiceProviderRequest): Promise<IServiceProvider> {
        const response = await axios.post<IServiceProvider>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, input: IServiceProviderRequest): Promise<IServiceProvider> {
        const response = await axios.put<IServiceProvider>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, serviceProviderId: string, currentIsDeleted: boolean): Promise<{ serviceProviderId: string }> {
        const response = await axios.delete<{ serviceProviderId: string }>(`${API_URL(organizationId)}/${serviceProviderId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new ServiceProviderService();